import React, { useState, useEffect } from "react";
import styles from "./Presentation.module.scss";
import "react-datepicker/dist/react-datepicker.css";
import BreadCrumb from "../CommonComponents/BreadCrumb.tsx";
import { Icon } from "../../assets/Icons.tsx";
import { investorPresentationData } from "../../redux/slices/investorSlice.js";
import { useDispatch } from "react-redux";

const Presentation: React.FC = () => {
  const breadcrumb = [
    { title: "Home", link: "/" },
    { title: "Investors", link: "/investors" },
    { title: "Presentation", link: "" },
  ];

  return (
    <>
      <BreadCrumb menu={breadcrumb} />
      <div className={styles.Presentation}>
        <div className="section">
          <div className="container-fluid">
            <div className="container">
              <div className="row">
                <div className="col-12">
                  <p className="heading">Investor Presentation</p>
                </div>
              </div>
            </div>
            <div>
              <ReleaseList />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Presentation;

const ReleaseList = () => {
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [yearRange, setYearRange] = useState([
    new Date().getFullYear(),
    new Date().getFullYear() - 4,
  ]);
  const [activeTab, setActiveTab] = useState(yearRange[0]);

  const handleNext = () => {
    setYearRange((prev) => [prev[0] - 5, prev[1] - 5]);

    console.log(yearRange, "yearRange555");
    setActiveTab(yearRange[1] - 1);
  };

  const handlePrevious = () => {
    setYearRange((prev) => [prev[0] + 5, prev[1] + 5]);
    console.log(yearRange, "llll");
    setActiveTab(yearRange[0] + 5);
  };

  const handleTabClick = (year) => {
    setActiveTab(year);
    setSelectedYear(year);
  };
  const [filteredPresentation, setFilteredPresentation] = useState([]);
  const [filteredCards, setFilteredCards] = useState(null);
  const [loading, setLoading] = useState(true);

  const dispatch = useDispatch();

  // Fetch News Data
  useEffect(() => {
    const fetchPresentationData = async () => {
      setLoading(true);
      try {
        const data = await dispatch(
          investorPresentationData(selectedYear)
        ).unwrap();
        console.log(data, "data");
        setFilteredPresentation(data?.investor_presentations || []);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching investor overview data:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPresentationData();
  }, [dispatch, selectedYear]);

  // Filter Cards by Year and Search Query
  useEffect(() => {
    const filterData = () => {
      if (activeTab) {
        setSelectedYear(activeTab);
      }
      const filteredYearData = filteredPresentation?.find(
        (item) => item?.year?.toString() === selectedYear.toString()
      );

      let filteredFiles = filteredYearData?.details || [];

      setFilteredCards(filteredFiles);
    };

    filterData();
  }, [selectedYear, filteredPresentation, yearRange, activeTab]);

  // Utility Functions
  const extractDay = (date) => {
    const dateObj = new Date(date);
    return dateObj.getDate();
  };

  const extractMonth = (date) => {
    try {
      const dateObj = new Date(date);
      if (isNaN(dateObj)) throw new Error("Invalid date format");
      return dateObj?.toLocaleString?.("default", { month: "short" });
    } catch (error) {
      console.error("Error extracting month:", error.message);
      return "Invalid Date";
    }
  };

  const nextDisabled = yearRange[1] > 2010 ? false : true;

  return (
    <>
      <div className="row mb-5 g-0">
        <div className="col-lg-12 col-md-12">
          <div className="container">
            <div className={`${styles.filters}`}>
              <div
                className={`${styles.year} d-flex justify-content-center align-items-center`}
              >
                <button
                  onClick={handlePrevious}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    color: "white",
                  }}
                  disabled={yearRange[0] >= new Date().getFullYear()}
                  className="d-flex justify-content-center align-items-center"
                >
                  <Icon
                    name="dropdownLeftArrow"
                    color="white"
                    width="25px"
                    height="25px"
                  />
                </button>
                <span
                  className="d-flex justify-content-center align-items-center"
                  style={{ fontSize: "24px" }}
                >
                  <Icon name="calender" color="white" />
                </span>
                <span className=" mb-0">&nbsp;Year |&nbsp;</span>

                <div className={styles.customSelect}>
                  <div className={` mb-0 ${styles.textPadding}`}>
                    <span className="text-center" style={{ color: "white" }}>
                      {yearRange[1] !== ""
                        ? `${yearRange[0]} - ${yearRange[1]}`
                        : yearRange[0]}
                    </span>
                  </div>
                </div>
                <button
                  onClick={handleNext}
                  style={{
                    background: "none",
                    border: "none",
                    cursor: "pointer",
                    color: "white",
                  }}
                  disabled={nextDisabled}
                  className="d-flex justify-content-center align-items-center"
                >
                  <Icon
                    name="dropdownRightArrow"
                    color="white"
                    width="25px"
                    height="25px"
                  />
                </button>
              </div>
            </div>
          </div>

          <ul
            className={`nav nav-pills ${styles.navPills} overflow-auto`}
            id="pills-tab"
            role="tablist"
            style={{ whiteSpace: "nowrap" }}
          >
            {Array.from(
              { length: yearRange[0] - yearRange[1] + 1 },
              (_, i) => yearRange[0] - i
            )
              // .filter((year) => year >= 2015) // Only include years >= 2015
              .map((year) => (
                <li
                  key={year}
                  className="nav-item flex-shrink-0"
                  role="presentation"
                >
                  <button
                    className={`para mb-0 ${styles.navLink} ${
                      activeTab === year ? styles.navLinkActive : ""
                    }`}
                    onClick={() => handleTabClick(year)}
                    type="button"
                    role="tab"
                    aria-controls={`pills-${year}`}
                    aria-selected={activeTab === year}
                  >
                    {year}
                  </button>
                </li>
              ))}
          </ul>
        </div>
      </div>

      {/* <p className={`heading ${styles.selectedFullYear}`}> {selectedYear}</p> */}

      {!loading ? (
        <div className="container">
          <div className={styles.header}>
            <div className="row">
              <div className="col-lg-2 col-md-2 col-sm-2 col-2">
                <p className={`para caps ${styles.colPadding}`}>
                  <strong>Date</strong>
                </p>
              </div>
              <div className="col-lg-9 col-md-8 col-sm-7 col-7">
                <p className="para caps">
                  <strong>Title</strong>
                </p>
              </div>
              <div className="col-lg-1 col-md-2 col-sm-3 col-3">
                <p className={`para caps ${styles.ViewColumnHeading}`}>
                  <strong>View</strong>
                </p>
              </div>
            </div>
          </div>
          <div className="mb-3">
            {filteredCards?.length > 0 &&
              filteredCards?.map((card, index) => (
                <div className={styles.brandCard} key={index}>
                  <div className="row">
                    <div className="col-lg-2 col-md-2 col-sm-2 col-2">
                      <div
                        className={`${styles.date} ${styles.colContentPadding}`}
                      >
                        <p
                          className={`para ${styles.cardDate} ${styles.cardMonth} mb-0 text-center`}
                        >
                          {extractMonth(card?.publish_date)}
                        </p>
                        <p
                          className={`${styles.cardDay} ${styles.cardDate} mb-0 text-center`}
                        >
                          {extractDay(card?.publish_date)}
                        </p>
                      </div>
                    </div>
                    <div className="col-lg-9 col-md-8 col-sm-7 col-7">
                      <p className={`para ${styles.cardTitle} mb-0`}>
                        {card?.title}
                      </p>
                    </div>
                    <div className="col-lg-1 col-md-2 col-sm-3 col-3">
                      <span style={{ fontSize: "24px", cursor: "pointer" }}>
                        <a
                          href={card?.document_path}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <Icon
                            name="eyeIcon"
                            color="#036995"
                            width="40px"
                            height="40px"
                          />
                        </a>
                      </span>
                    </div>
                  </div>
                </div>
              ))}

            {filteredCards?.length === 0 && (
              <div className={styles.brandCard}>
                <p className="subHeading text-center caps mt-4 mb-4">
                  No Data available
                </p>
              </div>
            )}
          </div>
        </div>
      ) : (
        <p className="para text-center">Loading...</p>
      )}
    </>
  );
};
